/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Demo_Composer_PlaceholderInputs */

const en_mcp_demo_composer_placeholder = /** @type {(inputs: Mcp_Demo_Composer_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask anything`)
};

const es_mcp_demo_composer_placeholder = /** @type {(inputs: Mcp_Demo_Composer_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pregunta lo que quieras`)
};

/**
* | output |
* | --- |
* | "Ask anything" |
*
* @param {Mcp_Demo_Composer_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_demo_composer_placeholder = /** @type {((inputs?: Mcp_Demo_Composer_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Demo_Composer_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_demo_composer_placeholder(inputs)
	return en_mcp_demo_composer_placeholder(inputs)
});